import ReactGA from "react-ga4";

export const onTenantClick = (id, setUserData, navigate, page) => {
  window.history.replaceState({}, document.title)
  ReactGA.gtag("set", "user_properties", {"Tenant": id});
  localStorage.setItem('tenant', id);
  setUserData((state) => ({...state, tenant: id, page: page}));
}
